<template>
  <tr v-if="secondRow">
    <td :colspan="type === 'merchant' ? '10' : '9'" class="no-border">
      <div id="coll1" class="collapse in" aria-expanded="true" style="" v-if="rows.length > 0">
        <table class="table no-margin">
          <tbody>
          <tr v-for="row in rows">
            <td style="width: auto;">{{row.str_name}} ({{row.str_store_number}})<br>{{row.str_address_street}} {{row.str_address_street_number}}, {{row.str_address_city}}</td>
            <td style="width: auto;">{{'stock_company' | translate}}: {{row.num_stock}}</td>
            <td class="text-right">Händlerpreis: {{row.s_sale_price | currency}}</td>
            <td :class="[loading ? 'text-muted' : '', 'text-center']"><button :disabled="loading" class="btn btn-sm btn-info" @click="retry(item, row)">{{'retry_line' | translate}}<i :class="['fa fa-refresh ml-5', loading ? 'fa-spin' : '']"></i></button></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="callout callout-info">
        <i class="fa fa-info-circle mr-5"></i>{{'no_stores' | translate}}
      </div>
    </td>
  </tr>
</template>

<script>
  export default {
    props: ['secondRow', 'type', 'rows', 'item'],
    name: "store-row",
    data () {
      return {
        loading: false
      }
    },
    methods: {
      retry (item, store) {
       this.loading = true
        API.put(`monitoring/order/line/${item.order_item_line_id}/retry`, {str_store_number: store.str_store_number, ti_mp_order: store.ti_mp_order})
          .then(response => {
            this.$store.commit('pushAlert', {dismiss: 4, type: 'success', message: `Process Started`, icon: 'icon fa fa-check', show: true})
            this.loading = false
            this.$emit('deleteRow', item)
          })
          .catch(error => {
            this.$store.commit('pushAlert', {dismiss: 4, type: 'danger', message: error.response.data.message, icon: 'fa fa-ban', show: true})
            this.loading = false
          })
      },
    },
    watch: {
      rows () {}
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tools/TableRows/storeRow.vue